module.exports = __webpack_public_path__ + "media/images/it/logo-altroconsumo-e1b5e6df21de777acc267a8cfa1f531f.png";